import { Type } from 'class-transformer';
import { SimplePaymentRequestRawDto } from './simple-payment-request-raw-dto';
import { WFECommunityResultDto } from '../../shared-workflow-module/_models/wfe-community-result-dto';

export class SimplePaymentRequestEditorResultDto {
    @Type(() => SimplePaymentRequestRawDto)
    paymentRequest: SimplePaymentRequestRawDto;

    @Type(() => WFECommunityResultDto)
    communityList: Array<WFECommunityResultDto>;
}
